import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderFooterLayout from '../components/header-footer-layout';
import ConsoleBookingNotice from './console-booking-notice';
import ConsoleLogoutPopup from './console-logout-popup';
import { consoleLogout } from '../utils/paths';
import useServiceAvailability from '../hooks/use-service-availability.ts';

const BookingConsole = () => {
    const navigate = useNavigate();
    const { available, messages } = useServiceAvailability();
    const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);

    return (
        <>
            <HeaderFooterLayout
                title="【 予約管理 】オペレーションの選択"
                withFooter={false}
                onHome={() => {
                    navigate('/console/bookings/');
                }}
                onLogout={() => {
                    setShowLogoutConfirmation(true);
                }}
            >
                <ConsoleBookingNotice
                    available={available || false}
                    messages={messages}
                    onNewBooking={() => navigate('new/')}
                    onSearchBooking={() => navigate('search/')}
                />
            </HeaderFooterLayout>
            {showLogoutConfirmation && (
                <ConsoleLogoutPopup
                    onOk={() => {
                        consoleLogout();
                        setShowLogoutConfirmation(false);
                    }}
                    onCancel={() => {
                        setShowLogoutConfirmation(false);
                    }}
                />
            )}
        </>
    );
};

export default BookingConsole;
